/**
 * 成本效率优化（Overseas patch 227 · D9）
 */
export const STORE_COST_OPTIMIZE_MENU_IDS = {
  group: 990163,
  desk: 990164,
  view: 990165,
  gate: 990166
}

export default STORE_COST_OPTIMIZE_MENU_IDS



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/storeCostOptimize.js